export const TOKEN = 'token';

export const SERVER_ROUTE = '/lideresaccion';
export const ADMIN_ROUTE = '/administrador';
export const FACIL_ROUTE = '/facilitador';
export const ALUMNO_ROUTE = '/alumno';

//ESTADOS
export const ESTADOS: any = [
    { label: 'Seleccione una opción', value: "" },
    { label: 'Activo', value: 1 },
    { label: 'Inactivo', value: 0 },
]


//PARAMETRIZACIÓN PARA TABLAS DEL MÓDULO ADMINISTRADOR
export const tableOptions: any = {
    filterType: 'dropdown',
    selectableRows: 'none',
    responsive: 'standard',
    print: false,
    elevation: 0,
    searchOpen: true,
    download: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 25, 100],
    textLabels: {
        body: {
            noMatch: "Sin resultados para mostrar",
            toolTip: "Ordenar",
            columnHeaderTooltip: (column: { label: any; }) => `ORDENAR POR ${column.label}`
        },
        pagination: {
            next: "Página siguiente",
            previous: "Página anterior",
            rowsPerPage: "#",
            displayRows: "de",
        },
        toolbar: {
            search: "Buscar",
            downloadCsv: "Exportar",
            print: "Imprimir",
            viewColumns: "Visualizar Columnas",
            filterTable: "Filtros",
        },
        filter: {
            all: "Todos",
            title: "FILTROS",
            reset: "REINICIAR",
        },
        viewColumns: {
            title: "MOSTRAR COLUMNAS",
            titleAria: "Ocultar/Mostar columnas",
        },
        selectedRows: {
            text: "Filas(s) seleccionada(s)",
            delete: "Delete",
            deleteAria: "Delete Selected Rows",
        },
    }
};